// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lQ4jt","name":"styles_name__2_iSk","phone":"styles_phone__1t_03"};